import { AdaBindMethodPipe } from '@adaptiva/core/common';
import { AlertComponentModule } from '@adaptiva/widgets/alert';
import { ButtonComponentModule } from '@adaptiva/widgets/button';
import { CardComponentModule } from '@adaptiva/widgets/card';
import { ContainerComponentModule } from '@adaptiva/widgets/container';
import { InputComponentModule } from '@adaptiva/widgets/input';
import { TextComponentModule } from '@adaptiva/widgets/text';
import { CommonModule } from '@angular/common';
import { NgModule, PipeTransform, Type } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ResetPasswordComponent } from './reset-password.component';

const WIDGETS: Type<any>[] = [
	AlertComponentModule,
	ButtonComponentModule,
	CardComponentModule,
	ContainerComponentModule,
	InputComponentModule,
	TextComponentModule
];

const PIPES: Type<PipeTransform>[] = [
	AdaBindMethodPipe
];

@NgModule({
	imports: [
		PIPES,
		WIDGETS,
		CommonModule,
		RouterModule.forChild([{
			path: '',
			title: 'Reset Password',
			component: ResetPasswordComponent
		}]),
	],
	declarations: [ResetPasswordComponent],
	exports: [ResetPasswordComponent],
})
export class ResetPasswordModule {

}
